export const carryParams = (elem) => {
  if (!(elem instanceof HTMLAnchorElement)) return;
  const allowed = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
    "fbclid",
    "msclkid",
    "ttclid"
  ];

  const currentParams = new URLSearchParams(window.location.search);

  // Nothing to do
  if ([...currentParams].length === 0) return;

  const url = new URL(elem.href);

  // Only add whitelisted params that don't already exist
  currentParams.forEach((value, key) => {
    if (allowed.includes(key) && !url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  });

  elem.href = url.toString();
};